/**
 * vl-button-group.js — 手机端「两个按钮同排」的换行回落测量（2026-10-20）
 *
 * 背景（用户口径）：
 *   - 默认：手机端按钮组单列换行（CSS 默认，本脚本不参与）。
 *   - 显性开启（`.vl-button-group--m-inline`）：优先同一行，按钮宽度＝各自文案宽度、不拉伸；
 *     只有一行真实放不下时，才回落为默认换行 —— 且换行后两枚等宽、宽度＝较长的那枚。
 *
 * 为什么需要 JS：
 *   「换行后两枚等宽＝较长那枚」与「不换行时各自按文案宽度」无法用纯 CSS 同时表达
 *   （flex 会拉伸或无法对齐最长项；grid 的 auto-fit 不接受 max-content 作为轨道尺寸）。
 *   因此这里只做一次测量：先去掉 `.is-m-stacked` 按 flex 量两枚按钮的 offsetTop，
 *   若第二枚已被挤到下一行，则加回 `.is-m-stacked`，由 CSS 切回单列 grid（等宽＝最长）。
 *
 * 触发时机：DOM 就绪、字体就绪、窗口尺寸变化、Shopify 编辑器 section 载入，
 *           以及 hero 轮播切屏后（`window.VLButtonGroup.sync()`，由 vl-hero-slider.js 调用）。
 */
(function () {
  /* 同一页面可能同时挂 hero 与 edge banner（各引一次本脚本）⇒ 只初始化一次 */
  if (window.VLButtonGroup) return;

  var SELECTOR = '.vl-button-group--m-inline';

  function syncOne(group) {
    try {
      var items = group.children;
      if (!items || items.length < 2) {
        group.classList.remove('is-m-stacked');
        return;
      }
      /* 不可见（未激活的轮播屏、PC 断点下被隐藏的副本）先跳过：此时 rect 全为 0，测量无意义 */
      if (!group.getClientRects().length) return;

      group.classList.remove('is-m-stacked'); // 回到 flex 才能量出「是否放得下」
      var first = items[0].getBoundingClientRect();
      var second = items[1].getBoundingClientRect();
      if (second.top > first.top + 1) group.classList.add('is-m-stacked');
    } catch (e) {
      /* 异常隔离：测量失败时保持 flex 自然宽度，不影响页面其它功能 */
    }
  }

  function syncAll() {
    var groups = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < groups.length; i++) syncOne(groups[i]);
  }

  window.VLButtonGroup = { sync: syncAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  var rafId = 0;
  window.addEventListener('resize', function () {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      syncAll();
    });
  });

  document.addEventListener('shopify:section:load', syncAll);

  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(syncAll);
  }
})();
